  $(document).ready(function() {
    $('.index_brand_slider').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              arrows: false,
              dots: false, 
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: false,
            }
          }
        ]
    }); 
    $('.index_customer_care_slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true, 
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            }
          }
        ]
    }); 
    $('.product_brand_slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false,
    }); 
    $('.index-review-slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    }); 
    
//     $('.about-columns-images-slider').slick({
//       infinite: false,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       dots: true,
//     }); 
    
      var payment_icon = setInterval(function(){
      if($(".afterpay-paragraph").length > 0){
        jQuery(".afterpay-text1").text("or 4 instalments of ");
    	jQuery(".afterpay-text2").text(" with ");
        clearInterval(payment_icon);
      }
    }, 100);
    
       $(document).on("click",".logo-box",function(e) {
      //$(this).siblings().toggle();
      var tab_id = $(this).attr('data-tab');
       $('.logo-box').removeClass('active');
      $('.index_brand_slider_content .logo-sub-text').removeClass('active');

      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    });
    
    $(document).on("click",".bundle-img-item",function(e) {
      //$(this).siblings().toggle();
      var tab_id = $(this).attr('data-id');
       $('.bundle-img-item').removeClass('active');
      $('.bundle-product-wrap').removeClass('active');

      $(this).addClass('active');
      $("#"+tab_id).addClass('active');
    });
    
    $(function() {
		 $(".bundle_submit1").click(function(e) {
        	e.preventDefault();
           	//var frmAction = $('.form_bundle_product1').serialize();
           	var bundle_product = $('input[name=bundle_id1]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
      
      	$(".bundle_submit2").click(function(e) {
        	e.preventDefault();
           	//var frmAction2 = $('.form_bundle_product2').serialize();
           	var bundle_product = $('input[name=bundle_id2]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
      
      	$(".bundle_submit3").click(function(e) {
        	e.preventDefault();
           	//var frmAction3 = $('.form_bundle_product3').serialize();
           	var bundle_product = $('input[name=bundle_id3]').val();
           	 $.ajax({
               	type: "POST",
                cache: false,
               	url: '/cart/add.js',
                data: { quantity: 1, id: bundle_product },
                async: false,
                xhrFields: { withCredentials: false },
                success: function(result){
               	  window.location.href= "/cart";
               	}
             });
         });
    });

      $('.index-customer-care-team .text-column__button-row .text-column__button').click(function(){
        $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).offset().top - 140
        }, 800);
        return false;
      });

    var payment_icon = setInterval(function(){
      
      if($(".afterpay-paragraph").length > 0){
        
        jQuery(".afterpay-text1").text("or 4 instalments of ");
    	jQuery(".afterpay-text2").text(" with ");
        
        clearInterval(payment_icon);

      }

    }, 100);


        $('.toggle-item').click(function(e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.next().hasClass('inner-show')) {
            $this.removeClass('active');
            $this.next().removeClass('inner-show');
            $this.next().slideUp(350); 
        } else { 
            $this.parent().parent().find('li .toggle-item ').removeClass('active');
            $this.toggleClass('active');
            $this.parent().parent().find('li .inner').removeClass('inner-show');
            $this.parent().parent().find('li .inner').slideUp(350); 
            $this.next().toggleClass('inner-show');
            $this.next().slideToggle(350); 
        } 
    });
    
  });